'use strict';

import Component from 'generic.basecomponent';
import $ from "jquery";
import helpers from 'helpers';
import app from 'app-instance';



export default class DonationSelector extends Component {
    constructor(el) {
        super(el);
        this.handleBtnClick = this.handleBtnClick.bind(this);

        this.$container = $(this.container);
        this.init();
    }

    init() {

        this.$btn = this.$container.find('.js-donaton-selector__btn');
        this.$input = this.$container.find('.js-donaton-selector__inp');

        this.$btn.on('click', this.handleBtnClick);
        this.$input.on('input', helpers.throttle(this, this.handleInput, 300));

    }

    handleBtnClick(e) {
        const $targetBtn = $(e.target);
        this.$btn.removeClass('is-active');
        $targetBtn.addClass('is-active');

        const value = $targetBtn.data('value');
        this.$input.val(value);
        app.emitEvent('donateAmount:input', [value]);
    }

    handleInput() {
        const inputVal = parseFloat(this.$input.val());
        this.$btn.each(( index, el ) => {
            const $el = $(el);

            if (inputVal ===  $el.data('value')) {
                $el.addClass('is-active');
            } else {
                $el.removeClass('is-active');
            }
        });

        app.emitEvent('donateAmount:input', [inputVal]);
    }


}



// WEBPACK FOOTER //
// ./app/components/donation-selector/js/generic.donation-selector.js